module.exports = __webpack_public_path__ + "media/newstyle/images/icon-cart-grey-aec3d83c2e13aeb1e0c5d620bd2db3b8.svg";